<template>
    <div>444</div>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {},
    mounted() {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/components/plugIn/dialog/index.vue